'use client';

import React from 'react';

import { center } from '@pt-group-fe/styled-system/patterns';
import { mainNavigation } from '@pt-group-fe/styled-system/recipes';
import * as NavRx from '@radix-ui/react-navigation-menu';

import { useHeaderBanner } from '@lib/hooks';
import type { Cms_FlyoutMenu, Cms_SitemapTree, Cms_SitemapTreeItem } from '@lib/services/cms';

import { NavItem } from './NavItem';

interface MainNavigationProps {
  sitemap?: Cms_SitemapTree;
  sitemapItem?: Cms_SitemapTreeItem;
  flyoutMenus?: Cms_FlyoutMenu[];
  hasHeaderBanner?: boolean;
  hasSearch: boolean;
}
const MainNavigation: React.FC<MainNavigationProps> = ({
  sitemap,
  sitemapItem,
  flyoutMenus,
  hasHeaderBanner,
  hasSearch
}) => {
  const rootItem = sitemap?.children?.find(item => item.pageId === 'home');
  const items = rootItem?.children?.filter(item => item.active && item.include.includes('header'));
  const isBannerActive = useHeaderBanner(hasHeaderBanner);
  const { viewPort, viewportPos } = mainNavigation({ isBannerActive });

  return (
    <NavRx.Root>
      <NavRx.List className={center({ listStyleType: 'none', m: 0, mr: !hasSearch ? -5 : 0 })}>
        {items?.map(item => (
          <NavItem
            data={item}
            key={item.id}
            flyoutMenu={flyoutMenus?.find(flm => flm.sitemapNode?.nodeId === item.id)}
            activeItemId={sitemapItem?.id}
          />
        ))}
      </NavRx.List>
      <div className={viewportPos}>
        <NavRx.Viewport className={viewPort} />
      </div>
    </NavRx.Root>
  );
};

export { MainNavigation };
export type { MainNavigationProps };
